import { render, staticRenderFns } from "./MealDetail.vue?vue&type=template&id=6e7f0d2e&scoped=true&"
import script from "./MealDetail.vue?vue&type=script&lang=js&"
export * from "./MealDetail.vue?vue&type=script&lang=js&"
import style0 from "./MealDetail.vue?vue&type=style&index=0&id=6e7f0d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7f0d2e",
  null
  
)

export default component.exports